import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userData: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    initialize(state, action) {
      state.userData = action.payload;
      state.isAuthenticated = true;
    },
    reset() {
      return initialState;
    },
    update(state, action) {
      state.userData = action.payload;
    },
  },
});

export const authActions = authSlice.actions;

export default authSlice;
